import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import router from "routes/routes";
import "./App.css";
import { SocketContext } from "context/SocketContext";
import OneSignal from "react-onesignal";

const App = ({ socket }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));

  const setUpOneSignal = async () => {
    try {

      if (!userData?.role?.isAdmin) return;

      await OneSignal.init({
        appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
        persistNotification: false,
        // allowLocalhostAsSecureOrigin: true,
        // notifyButton: { enable: true, position: "bottom-right", },
      });

      await OneSignal.Notifications.requestPermission();
      // await OneSignal.Notifications.requestPermission(true);


      if (!OneSignal.User.externalId && userData?.role?.isAdmin) {
        // if (!OneSignal.User.externalId) {
        await OneSignal.login(userData?._id);

        const uid = OneSignal.User.externalId;
        if (uid) {
          console.log("External Id is generated!");
        }
      }

      OneSignal.Notifications.addEventListener(
        "foregroundWillDisplay",
        (event) => {
          const notification = event.notification;

          event.preventDefault();

          notification.display();

          // setTimeout(() => {
          //   notification.dismiss();
          // }, 5000);
        }
      );
    } catch (error) {
      console.log("there was a error", error);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined" && userData?.role?.isAdmin) {
      setUpOneSignal();
    }

    return () => {
      OneSignal.Notifications.removeEventListener("foregroundWillDisplay");
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>
      <RouterProvider router={router} />
    </SocketContext.Provider>
  )
};

export default App;